module.exports = __webpack_public_path__ + "img/ava_ad1x2.7d1a1a7b.png";